import React, { useEffect } from 'react';
import Rupt from 'rupt';

import { getAccountSharingLogoutUrl } from '../utilities/urlHelper';

const AccountSharing = (props) => {

    useEffect(() => {
        if (window._ruptEnabled && window.userId) {
            Rupt.attach({
                metadata: {
                    userRole: window.userRole,
                },
                groups: [{
                    id: window.teamId,
                    metadata: {
                        planName: window.planName,
                    },
                }],
                client_id: window._ruptClientId,
                user: `${window.userId}`,
                appearance_config: {
                    font_family: '"Inter", "Helvetica Neue", Helvetica, sans-serif',
                },
                on_current_device_logout: () => {
                    window.location.href = getAccountSharingLogoutUrl();
                },
            }).catch(error => {
                console.error('Error attaching Rupt:', error);
            });
        }
    }, []);

    return null;
};

export default AccountSharing;
